import React, { createContext, useContext } from 'react';

import noop from 'lodash/noop';

import { TestCycle } from '@qality/common-model';
import { TestCaseInCycle } from '@qality/common-model/src/TestCaseInCycle';
import { ExecutionStatuses } from '@qality/common-service/src/ExecutionStatusService';

type TestCasesInCycleListContextValue = {
  testCaseActions: {
    removeTestCase: (testCase: TestCaseInCycle) => Promise<void>;
    addTestCases: (issuesIds: Array<string>) => Promise<void>;
    selectTestCases: (testCasesIds: Array<number | string>) => void;
  };
  testCycleActions: {
    updateTestCycle: (testCycle: TestCycle) => void;
  };
  testCycle: TestCycle;
  selectedTestCasesIds: Array<number | string>;
  executionStatuses: ExecutionStatuses;
};

export const initialContextValue: TestCasesInCycleListContextValue = {
  testCaseActions: {
    removeTestCase: (testCase: TestCaseInCycle) =>
      Promise.resolve(noop(testCase)),
    addTestCases: (issuesIds: Array<string>) =>
      Promise.resolve(noop(issuesIds)),
    selectTestCases: (testCasesIds: Array<number>) => noop(testCasesIds),
  },
  testCycleActions: {
    updateTestCycle: (testCycle: TestCycle) => noop(testCycle),
  },
  testCycle: null,
  selectedTestCasesIds: [],
  executionStatuses: { allStatuses: [], defaultStatus: null },
};

export const TestCasesInCycleListContext =
  createContext<TestCasesInCycleListContextValue>(initialContextValue);

export const useTestCasesInCycleList = (): TestCasesInCycleListContextValue => {
  return useContext(TestCasesInCycleListContext);
};

type Props = { children: React.ReactNode } & TestCasesInCycleListContextValue;

export function TestCasesInCycleListProvider({
  children,
  ...contextValue
}: Props): JSX.Element {
  return (
    <TestCasesInCycleListContext.Provider value={contextValue}>
      {children}
    </TestCasesInCycleListContext.Provider>
  );
}
